import isEqual from 'lodash/isEqual'

export default (modelType = [String, Number, Array], defaultValue = undefined, iValueKey = 'iValue') => {
	if (!Array.isArray(modelType)) modelType = [modelType]
	const props = { value: modelType }
	const isNumeric = modelType.includes(Number)
	const canBeMultiple = modelType.includes(Array)
	if (canBeMultiple) props.multiple = Boolean

	return {
		props,
		model: {
			prop: 'value',
			event: 'updateModel',
		},
		data() {
			return {
				[iValueKey]: defaultValue === undefined ? null : defaultValue,
			}
		},
		watch: {
			value: {
				deep: true,
				handler(value) {
					value = this.normalizeModelValue(value)
					if (!isEqual(value, this[iValueKey])) {
						this[iValueKey] = value
					}
				},
			},
			[iValueKey]: {
				deep: true,
				handler(value) {
					this.$emit('updateModel', value)
				},
			},
		},
		methods: {
			normalizeModelValue(v) {
				if (canBeMultiple && this.multiple) {
					if (v === undefined || v === null || v === '') return []
					if (!Array.isArray(v)) v = [v]
					return v.map((v) => (isNumeric ? Number(v) : v))
				} else {
					if (v === undefined || v === null || v === '')
						return defaultValue === undefined ? null : defaultValue
					return isNumeric ? Number(v) : v
				}
			},
		},
		created() {
			this[iValueKey] = this.normalizeModelValue(this.value)
		},
	}
}
